import React, { useCallback, useState } from 'react';
import { Box } from '@tanium/react-box';
import { Stack } from '@tanium/react-stack';
import { TaniumSpinner } from '@tanium/react-tanium-spinner';
import { TaniumLoginCard } from './TaniumLoginCard';
import { SignIn } from './SignIn';
import { AuthState, AuthCallbacks } from '../../auth/Auth';
import { NoticeAndConsent } from '../../components/FedRamp/NoticeAndConsent';
import { useComplianceFramework } from '../../hooks/useComplianceFramework';
import { ComplianceFramework } from '../../types';

interface LoginPageProps {
  auth: AuthCallbacks;
}

export const LoginPage: React.VFC<LoginPageProps> = ({ auth }) => {
  const { authState, signIn, signInIdp } = auth;
  const isGov = useComplianceFramework() === ComplianceFramework.USGov;
  const [showFedRampNotice, setShowFedRampNotice] = useState(isGov);

  const onFedRampAgreementClick = useCallback(() => {
    setShowFedRampNotice(false);
  }, []);

  const renderAuthComponent = () => {
    switch (authState) {
      case AuthState.SIGN_IN:
        return <SignIn onSignIn={signIn} onSignInIdp={signInIdp} />;
    }
    return <TaniumSpinner />;
  };

  return (
    <Box as={Stack} justifyContent="center" marginTop="150px">
      {showFedRampNotice ? (
        <NoticeAndConsent onAgreementClick={onFedRampAgreementClick} />
      ) : (
        <TaniumLoginCard>{renderAuthComponent()}</TaniumLoginCard>
      )}
    </Box>
  );
};
